import { getCss, buildResponsiveStyles, mergeDeep, color } from '../../utils';
import {
  ContentWidthType,
  TContentWidth,
  ContentBackgroundColorType,
  TContentBackgroundColor,
  ContentBackgroundFullType,
  TContentBackgroundFull,
} from './content-wrapper-utils';

export const createStyles = (
  width: TContentWidth,
  backgroundColor: TContentBackgroundColor,
  backgroundFull: TContentBackgroundFull
): string => {
  return getCss({
    '@global': {
      ':host': {
        display: 'flex',
      },
      '.dc-ui-content-wrapper': {
        boxSizing: 'border-box',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '100%',
        minWidth: '0px',
        ...mergeDeep(
          buildResponsiveStyles(width, (widthResponsive: ContentWidthType) => ({
            maxWidth:
              widthResponsive === 'fluid'
                ? '100%'
                : widthResponsive === 'basic'
                ? '1200px'
                : '1600px',
            padding: widthResponsive === 'basic' ? '0 15px' : '',
          })),
          buildResponsiveStyles(
            backgroundFull,
            (backgroundFullResponsive: ContentBackgroundFullType) => ({
              position: 'relative',
              '&::before': {
                content: '""',
                display: backgroundFullResponsive ? 'block' : 'none',
                position: 'absolute',
                inset: 0,
                pointerEvents: 'none',
                clipPath: 'inset(0 -100vmax)',
                ...mergeDeep(
                  buildResponsiveStyles(
                    backgroundColor,
                    (backgroundColorResponsive: ContentBackgroundColorType) => ({
                      boxShadow: `0 0 0 100vmax ${color[backgroundColorResponsive]}`,
                    })
                  )
                ),
              },
            })
          ),
          buildResponsiveStyles(
            backgroundColor,
            (backgroundColorResponsive: ContentBackgroundColorType) => ({
              backgroundColor: backgroundColorResponsive
                ? color[backgroundColorResponsive]
                : color.white,
            })
          )
        ),

        '&> *': {
          flexShrink: 0,
          flexGrow: 0,
        },
      },
      '.dc-ui-slant': {
        position: 'relative',
        left: '50%',
        width: '100vw',
        marginLeft: '-50vw',

        '&--top span': {
          display: 'block',
          position: 'relative',
          backgroundColor: 'transparent',
          width: 0,
          height: 0,
          borderLeft: '0px solid',
          borderTop: '7vw solid transparent',
          borderBottom: '0px solid',
          ...mergeDeep(
            buildResponsiveStyles(
              backgroundColor,
              (backgroundColorResponsive: ContentBackgroundColorType) => ({
                borderRight: `100vw solid ${color[backgroundColorResponsive]}`,
              })
            )
          ),
        },

        '&--bottom span': {
          display: 'block',
          position: 'relative',
          backgroundColor: 'transparent',
          width: 0,
          height: 0,
          borderLeft: '0px solid',
          ...mergeDeep(
            buildResponsiveStyles(
              backgroundColor,
              (backgroundColorResponsive: ContentBackgroundColorType) => ({
                borderTop: `7vw solid ${color[backgroundColorResponsive]}`,
              })
            )
          ),
          borderRight: '100vw solid transparent',
          borderBottom: '0px solid',
        },
      },
    },
  });
};
